import { AnimatePresence, easeIn, motion } from "framer-motion";
import { useNavbar } from "../../hooks/useNavbar"

export const OverlayBody = () => {
    const {context} = useNavbar();

    return (
        <AnimatePresence initial={false}>
            {context.isOpen && 
                <motion.div 
                initial={{opacity:1}} 
                animate={{opacity:0.7}} 
                exit={{opacity:0}}
                transition={{ type:"spring", stiffness:200, damping:50, ease:easeIn, delay:.2 }}
                className={`bg-black top-0 left-0 z-10 fixed w-screen h-screen`}
                ></motion.div>
            }
        </AnimatePresence>
        
    )
}